let hash = {};
let query = {};

export const hasher = {
    name: 'hasher',
    store() {
        return {
            hash: {},
            query: {},
            init() {
            },
            setHash(key, value) {
                console.debug('Hashing secret: ', key, value);
                hash[key] = value;
                return hash;
            },
            getHash(key) {
                console.debug('Hash retrieved: ', key, hash[key]);
                return hash[key];
            },
            dispatchHash() {
                let hashEv = new Event('hash', { bubbles: true });
                dispatchEvent(hashEv);
            },
            setQuery(key, value) {
                console.debug('Query set: ', key, value);
                query[key] = value;
                return query;
            },
            getQuery(key) {
                console.debug('Query retrieved: ', key, query[key]);
                return query[key];
            }
        }
    }
}
export default hasher;
